module.exports = __webpack_public_path__ + "static/media/trending-designs-in-2020.8e1efcf2.md";